import { ARRANGE_BENCH, ARRANGE_HAND } from './constants';

/** Moves your benched Pokémon at `from` to the spot `to`, swapping with the one there if any. */
export const arrangeBench = (from, to) => ({
  type: ARRANGE_BENCH,
  payload: { from, to },
});

/** Moves the card at hand position `from` to `to`, the cards between shifting over. */
export const arrangeHand = (from, to) => ({
  type: ARRANGE_HAND,
  payload: { from, to },
});
